import { render, staticRenderFns } from "./Form-claim.vue?vue&type=template&id=bf02f738&scoped=true"
import script from "./Form-claim.vue?vue&type=script&lang=js"
export * from "./Form-claim.vue?vue&type=script&lang=js"
import style0 from "./Form-claim.vue?vue&type=style&index=0&id=bf02f738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf02f738",
  null
  
)

export default component.exports